/** Eszközfelismerés: telefon/tablet (érintés) és mobil-specifikus módkorlátozások. */

const params = (): URLSearchParams => {
  if (typeof window === 'undefined') return new URLSearchParams();
  return new URLSearchParams(window.location.search);
};

/** Van-e érintőképernyő (vagy kézzel kényszerítve a ?touch=1). */
export const isTouchDevice = (): boolean => {
  if (typeof window === 'undefined') return false;
  const q = params();
  if (q.get('touch') === '1') return true;
  if (q.get('touch') === '0') return false;
  return navigator.maxTouchPoints > 0 || window.matchMedia('(pointer: coarse)').matches;
};

/**
 * Mobilon (érintés + kicsi képernyő) csak egyjátékos mód van.
 * Asztali gépen érintőképernyővel is maradhat a coop, ezért a képernyőméret is számít.
 */
export const isMobileDevice = (): boolean => {
  if (!isTouchDevice()) return false;
  const q = params();
  if (q.get('mobile') === '1') return true;
  if (q.get('mobile') === '0') return false;
  const coarse = window.matchMedia('(pointer: coarse)').matches;
  const small = Math.min(window.screen.width || window.innerWidth, window.screen.height || window.innerHeight) <= 900;
  return coarse || small;
};

/** Fekvő tájolás ajánlott a versenyhez. */
export const isPortrait = (): boolean => {
  if (typeof window === 'undefined') return false;
  return window.innerHeight > window.innerWidth;
};
